/*
 * Photography for the /biljetter page.
 *
 * Served from the WordPress media library rather than bundled into the CRA build:
 * WordPress generates the responsive sizes and fronts them with its own cache, and the
 * bundle stays small. The jubileumsväska image already worked this way.
 */

const UPLOADS = 'https://harmoniexpo.com/wp-content/uploads'

export const photos = {
	// Hero background.
	heroProgram: `${UPLOADS}/2026/09/Besokare-tittar-i-programmet-Harmoni-Expo.jpg`,
	// The four square tiles under "Mer än en mässa, en upplevelse".
	moten: `${UPLOADS}/2026/09/Moten-och-samtal-pa-Harmoni-Expo.jpg`,
	besokare: `${UPLOADS}/2026/09/Besokare-pa-Harmoni-Expo.jpg`,
	meditation: `${UPLOADS}/2026/09/Meditation-i-jubilumstaltet-Harmoni-Expo.jpg`,
	scenen: `${UPLOADS}/2026/09/Scenen-gemenskap-pa-Harmoni-Expo.jpg`,
}

export const jubileumsvaska = `${UPLOADS}/2026/01/harmoni_expo_jubileumsvaska.png`
